(function () {
  'use strict';

  function getRoot() {
    return document.querySelector('[data-velvety-cart]');
  }

  function getSectionId(root) {
    return root.getAttribute('data-section-id');
  }

  /* ============================================================
     Cart fetch helpers
     ============================================================ */
  function changeLine(key, quantity, sectionId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (j) { throw new Error(j.description || 'Update failed'); });
      }
      return res.json();
    });
  }

  function clearCart(sectionId) {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        sections: sectionId,
        sections_url: window.location.pathname
      })
    }).then(function (res) { return res.json(); });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) { if (!res.ok) throw new Error('Add failed'); return res.json(); });
  }

  /* ============================================================
     Section re-render
     ============================================================ */
  function rerender(html) {
    /* Extract just the [data-velvety-cart] body and swap it into the page. */
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-velvety-cart]');
    var current = getRoot();
    if (!fresh || !current) return;

    /* Preserve toast element across rerender (it lives outside the section's inner content) */
    var toast = current.querySelector('[data-velvety-cart-toast]');

    current.innerHTML = fresh.innerHTML;

    if (toast) {
      var newToast = current.querySelector('[data-velvety-cart-toast]');
      if (newToast && newToast.parentNode) newToast.parentNode.replaceChild(toast, newToast);
    }

    /* Refresh cart drawer + header bubble if Dawn helpers exist */
    syncOtherCartUIs();
    bindAll();
  }

  function syncOtherCartUIs() {
    /* If a cart-drawer custom element is on the page, refresh its content. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      fetch('/?sections=' + drawer.getSectionsToRender().map(function (s) { return s.section; }).join(','))
        .then(function (r) { return r.json(); })
        .then(function (sections) { drawer.renderContents({ sections: sections }); })
        .catch(function () { /* noop */ });
    }
    /* Header bubble */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var vc = c.item_count;
        document.querySelectorAll('[data-velvety-cart-count-badge], .velvety-icons__count, .cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = String(vc);
        });
      }).catch(function () { /* noop */ });
  }

  /* ============================================================
     Toast
     ============================================================ */
  var toastTimer = null;
  function showToast(msg) {
    var root = getRoot();
    if (!root) return;
    var toast = root.querySelector('[data-velvety-cart-toast]');
    if (!toast) return;
    toast.textContent = msg;
    toast.removeAttribute('hidden');
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.setAttribute('hidden', 'hidden'); }, 250);
    }, 2400);
  }

  /* ============================================================
     Row actions
     ============================================================ */
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function bindRows() {
    var root = getRoot();
    if (!root) return;
    var sectionId = getSectionId(root);

    root.querySelectorAll('[data-velvety-cart-row]').forEach(function (row) {
      if (row.__velvetyBound) return;
      row.__velvetyBound = true;

      var key = row.getAttribute('data-cart-key');
      var qtyInput = row.querySelector('[data-velvety-cart-qty]');
      var stepBtns = row.querySelectorAll('[data-velvety-cart-qty-step]');
      var removeBtn = row.querySelector('[data-velvety-cart-remove]');
      var moveBtn = row.querySelector('[data-velvety-cart-move-wishlist]');

      var commitQty = debounce(function (newQty) {
        if (isNaN(newQty) || newQty < 0) return;
        changeLine(key, newQty, sectionId)
          .then(function (res) {
            if (res && res.sections && res.sections[sectionId]) {
              rerender(res.sections[sectionId]);
              showToast(newQty === 0 ? 'Removed from bag' : 'Updated');
            }
          })
          .catch(function (err) {
            showToast(err.message || 'Could not update');
            if (qtyInput) qtyInput.value = qtyInput.defaultValue;
          });
      }, 350);

      stepBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var delta = parseInt(b.getAttribute('data-velvety-cart-qty-step'), 10) || 0;
          var current = parseInt(qtyInput.value, 10) || 0;
          var next = Math.max(0, current + delta);
          qtyInput.value = String(next);
          if (next === 0) row.classList.add('is-removing');
          commitQty(next);
        });
      });

      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          var v = parseInt(qtyInput.value, 10);
          if (isNaN(v) || v < 0) v = 0;
          qtyInput.value = String(v);
          if (v === 0) row.classList.add('is-removing');
          commitQty(v);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          row.classList.add('is-removing');
          if (qtyInput) qtyInput.value = '0';
          commitQty(0);
        });
      }

      if (moveBtn) {
        moveBtn.addEventListener('click', function () {
          if (!window.VelvetyWishlist || typeof window.VelvetyWishlist.add !== 'function') {
            showToast('Wishlist unavailable');
            return;
          }
          var options = (moveBtn.getAttribute('data-option-values') || '').split('|').filter(Boolean);
          var optionNames = (moveBtn.getAttribute('data-option-names') || '').split('|').filter(Boolean);
          window.VelvetyWishlist.add({
            handle: moveBtn.getAttribute('data-product-handle'),
            title: moveBtn.getAttribute('data-product-title'),
            url: moveBtn.getAttribute('data-product-url'),
            image: moveBtn.getAttribute('data-product-image'),
            price: moveBtn.getAttribute('data-variant-price'),
            price_cents: moveBtn.getAttribute('data-variant-price-cents'),
            variant_id: moveBtn.getAttribute('data-variant-id'),
            variant_title: moveBtn.getAttribute('data-variant-title'),
            options: options,
            option_names: optionNames
          });
          row.classList.add('is-removing');
          if (qtyInput) qtyInput.value = '0';
          commitQty(0);
          showToast('Moved to wishlist');
        });
      }
    });
  }

  /* ============================================================
     Clear cart
     ============================================================ */
  function bindClear() {
    var root = getRoot();
    if (!root) return;
    var btn = root.querySelector('[data-velvety-cart-clear]');
    if (!btn || btn.__velvetyBound) return;
    btn.__velvetyBound = true;
    btn.addEventListener('click', function () {
      if (!window.confirm('Remove all items from your cart?')) return;
      clearCart(getSectionId(root))
        .then(function (res) {
          if (res && res.sections && res.sections[getSectionId(root)]) {
            rerender(res.sections[getSectionId(root)]);
          } else {
            window.location.reload();
          }
          showToast('Cart cleared');
        })
        .catch(function () { showToast('Could not clear cart'); });
    });
  }

  /* ============================================================
     Gift card / discount banner
     ============================================================ */
  function bindGiftCard() {
    var root = getRoot();
    if (!root) return;
    var trigger = root.querySelector('[data-velvety-cart-giftcard-trigger]');
    var form = root.querySelector('[data-velvety-cart-giftcard-form]');
    if (!trigger || !form || trigger.__velvetyBound) return;
    trigger.__velvetyBound = true;
    trigger.addEventListener('click', function () {
      var open = form.hasAttribute('hidden');
      if (open) {
        form.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
        var input = form.querySelector('input[name="discount"]');
        if (input) setTimeout(function () { input.focus(); }, 20);
      } else {
        form.setAttribute('hidden', 'hidden');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var code = (input && input.value || '').trim();
      if (!code) return;
      /* Shopify applies discount codes via the /discount/<code> URL.
         We redirect there and back to the cart page; the code persists into checkout. */
      window.location = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });
  }

  /* ============================================================
     Checkout submit guard
     ============================================================ */
  function bindForm() {
    var root = getRoot();
    if (!root) return;
    var form = root.querySelector('[data-velvety-cart-form]');
    if (!form || form.__velvetyBound) return;
    form.__velvetyBound = true;
    /* Default action posts to /cart and goes to checkout when "checkout" submit button is used. */
  }

  function bindAll() {
    bindRows();
    bindClear();
    bindGiftCard();
    bindForm();
  }

  function init() {
    bindAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
